module.exports = __webpack_public_path__ + "img/HT01077-84.f9c1eafe.jpg";